import { media } from '../../../../utils/styles'
import styled from 'styled-components'
import NxHeading from '../../../../components/heading/NxHeading'

export const MenuContainer = styled.section`
  --menu-width: 230px;
  --menu-gap: var(--spacing-size-xs);
  --menus-per-line: 4;

  margin: var(--spacing-size-3xs) auto 0;
  display: flex;
  max-width: calc(
    calc(var(--menu-width) * var(--menus-per-line)) +
      calc(var(--menu-gap) * calc(var(--menus-per-line) - 1))
  );
  flex-wrap: wrap;
  gap: var(--menu-gap);
  justify-content: center;
  align-items: stretch;

  & > .card {
    width: var(--menu-width);
    min-height: 230px;
  }

  ${media.laptop`
    --menus-per-line: 3;
  `}

  ${media.tablet`
    --menus-per-line: 2;

    margin: var(--spacing-size-3xs) auto;
  `}

  ${media.mobile`
    --menus-per-line: 1;
  `}

  ${media.smallMobile`
    --menu-width: 210px;
  `}
`

export const MenuTitle = styled(NxHeading)`
  margin: 14px 0;
  display: block;
  height: 22px;
  cursor: default;
`

export const MenuList = styled.ul`
  margin: 0;
  padding-left: 24px;
`

export const MenuListItem = styled.li`
  &::marker {
    font-size: 0.75rem;
  }
`
